module.exports = __webpack_public_path__ + "img/product-shot_07.1d9ed325.jpg";